import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { KrystleRothApp } from "./KrystleRothApp";
const path = window.location.pathname.replace(/\/+$/, "").toLowerCase().replace(/-/g, "");
const isKrystle = path === "/krystleroth" || path === "/krystalroth";
const Root = isKrystle ? KrystleRothApp : App;
render(<Root data-id="element-609" />, document.getElementById("root"));